import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import ListingItem from '../components/ListingItem';
import Spinner from '../components/Spinner';
import { toast } from 'react-toastify';

export default function Trending() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTrendingListings() {
      try {
        const listingsRef = collection(db, 'listings');
        // First try to get listings ordered by viewCount
        const listingsQuery = query(listingsRef, orderBy('viewCount', 'desc'));
        const listingsSnap = await getDocs(listingsQuery);
        
        let listingList = listingsSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // If no listings with viewCount, fall back to timestamp
        if (listingList.length === 0) {
          const fallbackQuery = query(listingsRef, orderBy('timestamp', 'desc'));
          const fallbackSnap = await getDocs(fallbackQuery);
          listingList = fallbackSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          toast.info('Showing recent listings instead of trending');
        }

        // Initialize viewCount if missing
        listingList = listingList.map(listing => ({
          ...listing,
          viewCount: listing.viewCount || 0
        }));

        setListings(listingList);
      } catch (error) {
        console.error('Error fetching listings:', error);
        // Fallback to simple timestamp-based query if the viewCount query fails
        try {
          const listingsRef = collection(db, 'listings');
          const fallbackQuery = query(listingsRef, orderBy('timestamp', 'desc'));
          const fallbackSnap = await getDocs(fallbackQuery);
          const listingList = fallbackSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            viewCount: 0
          }));
          setListings(listingList);
          toast.info('Showing recent listings instead of trending');
        } catch (fallbackError) {
          toast.error('Failed to load listings');
          console.error('Fallback error:', fallbackError);
        }
      } finally {
        setLoading(false);
      }
    }
    fetchTrendingListings();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <main className="min-h-screen py-2 px-2 sm:px-4 bg-black">
      <div>
        <h2 className="text-gray-400 text-lg font-medium px-4 mb-3">Trending Listings</h2>

        <div className="movie-masonry">
          {listings.length > 0 ? (
            listings.map(listing => (
              <div key={listing.id} className="masonry-item">
                <ListingItem listing={listing} />
              </div>
            ))
          ) : (
            <p className="text-gray-400 text-center w-full">No listings found</p>
          )}
        </div>
      </div>
    </main>
  );
}

// Inject styles (same as before)
const styles = `
  .movie-masonry {
    column-count: 2;
    column-gap: 6px;
    padding: 0 4px;
  }

  @media (min-width: 640px) {
    .movie-masonry {
      column-count: 3;
    }
  }

  @media (min-width: 1024px) {
    .movie-masonry {
      column-count: 4;
    }
  }

  .masonry-item {
    break-inside: avoid;
    margin-bottom: 6px;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);